<template>
    <div>
        <p class="h4">Times</p>
        <p v-html="times"></p>
    </div>

</template>

<script>
    import moment from 'moment';
    export default {
        name: "TimesBlock",
        props: ['event'],
        data(){
            return {
                days:[]
            }
        },

        computed:{
            times(){
                //return event;
                let days = this.days;

                return days.map(d=>{
                    return `${moment(d.date).format("MMM Do YYYY")}
                            ${moment(d.start_time,['HH:mm:ss']).format("h:mm a")} to ${moment(d.end_time,['HH:mm:ss']).format("h:mm a")}`;
                }).join('<br/>')
            }
        },

        mounted(){
            this.days = this.event.days.sort((a,b)=>{
                let dateA = new Date(a.date), dateB = new Date(b.date);
                return dateA - dateB;
            });
        }


    }
</script>

<style scoped>

</style>